export default __webpack_public_path__ + "static/media/logoRedonto.7fc6f3d4.png";